/** A custom element constructor that carries its own tag name.
 *  Requires the class to declare `static tag = 'my-element'`.
 *  Lets qry() infer both the selector string and the return type
 *  from a single argument, eliminating the need to specify both. */
interface TaggedConstr<WC extends HTMLElement> {
  new(...args: any[]): WC;
  /** The custom element tag name, e.g. 'as-configurator' */
  tag: string;
}
// Extend Element so any element ref gains a scoped .qry() method

declare global {
  interface Element {
    qry<WC extends HTMLElement>(cons: TaggedConstr<WC>): WC | null;
  }
}
// Scoped querySelector — searches within `this` instead of document
Element.prototype.qry = function <WC extends HTMLElement>(cons: TaggedConstr<WC>): WC | null {
  return this.querySelector(cons.tag) as WC | null;
};
// Document-level querySelector shorthand
export const qry = <WC extends HTMLElement>(cons: TaggedConstr<WC>): WC | null => document.querySelector(cons.tag) as WC | null;
